import { render, staticRenderFns } from "./ticketReview.vue?vue&type=template&id=87ce566a&scoped=true&"
import script from "./ticketReview.vue?vue&type=script&lang=js&"
export * from "./ticketReview.vue?vue&type=script&lang=js&"
import style0 from "./ticketReview.vue?vue&type=style&index=0&id=87ce566a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ce566a",
  null
  
)

export default component.exports